import {API_BASE, request} from "./client";

/** Registration, login and profile. Phone/email ownership is proven through phone.email: the widget hands the page a
 * userJsonUrl and the backend fetches the verified number/email from phone.email itself. */

const OGM_WHATSAPP = "918309120616";

export const verifyPhone = (userJsonUrl) =>
    request("/broker/verify-phone", {method: "POST", body: {userJsonUrl}, auth: null});

export const verifyEmail = (userJsonUrl) =>
    request("/broker/verify-email", {method: "POST", body: {userJsonUrl}, auth: null});

export const registerBroker = (payload) =>
    request("/broker/register", {method: "POST", body: payload, auth: null});

export const loginBroker = (userJsonUrl) =>
    request("/broker/login", {method: "POST", body: {userJsonUrl}, auth: null});

export const getProfile = () => request("/broker/profile");

export const updateProfile = (changes) => request("/broker/profile", {method: "PUT", body: changes});

export const registerWithGoogle = () => {
    window.location.href = `${API_BASE}/auth/google?role=broker`;
};

const whatsappMessage = (form, areas, types) => {
    const divider = "----------------------------";
    const or = (v, fallback = "Not provided") => (v && String(v).trim()) || fallback;
    return `${divider}
*Agent/Developer REGISTRATION REQUEST*
*One Global Marketplace*
${divider}

*Registering as:* ${form.accountType === "BUILDER" ? "Builder / Developer" : "Agent / Broker"}
*Name:* ${or(form.fullName)}
*Company:* ${or(form.companyName)}
*RERA Number:* ${or(form.reraNumber, "N/A")}
*Mobile:* +91 ${or(form.mobile)}
*Email:* ${or(form.email)}
*Office Address:* ${or(form.officeAddress)}
*Operating Areas:* ${areas.length ? areas.join(", ") : "Not provided"}
*Property Types:* ${types.length ? types.map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(", ") : "Not provided"}
*No. of Properties:* ${or(form.numberOfProperties)}

${divider}
*Declaration:* I confirm I am an authorized Agent/Developer and agree to the Terms & Conditions of One Global Marketplace.

_Kindly process my broker registration._
${divider}`;
};

/** Opens WhatsApp with the details pre-written, and records the (unverified) registration so the team can follow up. */
export const registerWithWhatsApp = async (form, areas = [], types = []) => {
    window.open(`https://wa.me/${OGM_WHATSAPP}?text=${encodeURIComponent(whatsappMessage(form, areas, types))}`, "_blank");
    if (!form.email || !form.email.trim()) return;
    await request("/broker/whatsapp-register", {
        method: "POST",
        auth: null,
        body: {
            fullName: form.fullName || "",
            companyName: form.companyName || "",
            reraNumber: form.reraNumber || null,
            mobile: form.mobile || "",
            email: form.email.trim(),
            officeAddress: form.officeAddress || "",
            numberOfProperties: Number(form.numberOfProperties) || 0,
            operatingAreas: areas,
            propertyTypes: types,
            accountType: form.accountType || "AGENT",
            authProvider: "WHATSAPP",
        },
    });
};
